<template>
  <div class="watermark">
    <span class="mark" ref="mark">{{ mark }}</span>
  </div>
</template>

<script>
export default {
  props: ['mark'],
  data() {
    return {
      
    }
  },
  mounted() {
    this.move()
    setInterval(this.move, 2000)
  },
  computed: {
    markWidthPercent() {
      let client = document.body.clientWidth
      return this.$refs.mark.clientWidth / client * 100
    },
    markHeightPercent() {
      let client = document.body.clientHeight
      return this.$refs.mark.clientHeight / client * 100
    },
  },
  methods: {
    move() {
      if(!this.$refs.mark) {
        return
      }
      this.$refs.mark.style.left = `${this.random('width')}%`
      this.$refs.mark.style.top = `${this.random('height')}%`

    },
    random(type) {
      if(type == 'width') {
        return parseInt(Math.random() * (100 - 2 * this.markWidthPercent) + this.markWidthPercent)
      }
      else {
        return parseInt(Math.random() * (100 - 2 * this.markHeightPercent) + this.markHeightPercent)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.watermark {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  color: $grey-1;
  font-size: 14px;
  font-weight: 300;
  .mark {
    position: absolute;
    z-index: 1;
    display: inline-block;
    -webkit-transform: rotateX(-45deg);
    -moz-transform: rotateX(-45deg);
    -ms-transform: rotateX(-45deg);
    -o-transform: rotateX(-45deg);
    transform: rotate(-45deg);
    pointer-events: none;
  }
}
</style>